import { IUser } from './user.model';

export interface IAnalytic {
    trackEvent(action: string, app: string, data?: { [index: string]: any }, user?: IUser): void;
}
